export const MetricChartDotRadius = 6;
export const MetricChartYAxisWidth = 34;
export const MetricChartXAxisHeight = 24;
export const MetricChartDotSmall = {r: 1, fill: 'var(--neutral-6)', stroke: 'var(--neutral-6)'};